export default {
  IcbLevel1: 'Icb Level 1',
  IcbLevel2: 'Icb Level 2',
  IcbLevel3: 'Icb Level 3',
  IcbLevel4: 'Icb Level 4',
  listTitleTable: {
    SECTOR: 'Sector', // hh:mm
    CLOSE_INDEX: 'Last',
    TOTAL_VOLUME: 'Total Volume',
    TOTAL_VALUE: 'Total Value',
    TOTAL_MATCH_VOLUME: 'Match Volume',
    TOTAL_MATCH_VALUE: 'Match Value',
    PERCENT_INDEX_CHANGE: '% 1D Change',
    VOLUME_RATIO: 'Break-out Volume Ratio',
    VALUE_RATIO: 'Break-out Volume Ratio',
    PERCENT_1D_CHANGE: '%1D Change',
    PERCENT_1W_CHANGE: '%5D Change',
    PERCENT_2W_CHANGE: '%10D Change',
    PERCENT_1M_CHANGE: '%20D Change',
    AVG_VALUE_1W: 'Match Val./ Avg Match Val. 5D',
    AVG_VALUE_2W: 'Match Val./ Avg Match Val. 10D',
    AVG_VALUE_1M: 'Match Val./ Avg Match Val. 20D',
    AVG_VOLUME_1W: 'Match Vol./ Avg Match Vol. 5D',
    AVG_VOLUME_2W: 'Match Vol./ Avg Match Vol. 10D',
    AVG_VOLUME_1M: 'Match Vol./ Avg Match Vol. 20D',
  },
  timeRange: {
    ONE_DAY: '1 DAY',
    FIVE_DAY: '5 DAYS',
    TEN_DAY: '10 DAYS',
    TWENTY_DAY: '20 DAYS',
  },
  legend: {
    totalVolume: 'Match Volume',
    percentPriceChange: '%1D Change',
  },
  xAxis: {
    totalVolume1D: 'Match Volume (million shares)',
    totalVolume5D: 'Average Volume 5D (million shares)',
    totalVolume10D: 'Average Volume 10D (million shares)',
    totalVolume20D: 'Average Volume 20D (million shares)',
    percentPriceChange1D: '%1D Change',
    percentPriceChange5D: '%5D Change',
    percentPriceChange10D: '%10D Change',
    percentPriceChange20D: '%20D Change',
  },
  tooltip: {
    volume: 'Match Volume',
    volume5D: 'Average Match Volume 5D',
    volume10D: 'Average MatchVolume 10D',
    volume20D: 'Average MatchVolume 20D',
    percentPriceChange1D: '%1D Change',
    percentPriceChange5D: '%5D Change',
    percentPriceChange10D: '%10D Change',
    percentPriceChange20D: '%20D Change',
    value: 'Match Value',
    value5D: 'Average Match Volume 5D',
    value10D: 'Average Match Volume 10D',
    value20D: 'Average Match Volume 20D',
    unitValue: 'Mil. VND',
    unitVolume: 'Mil. Shares',
  },
  chartName: 'SECTOR PERFORMANCE',
  footer:
    'Volume: x 1,000. Value: x 1,000,000. Each sectors include all tickers from HOSE, HNX and UPCOM. (Hose realtime data is intergrated into industrial realtime data after 9h15 AM)',
};
